import React from 'react';

import { BringgFontIcons, BringgIcon } from '@bringg/bringg-icons';
import { BringgPopover, Button } from '@bringg/react-components';
import { useMonitoringTranslations } from '@bringg-frontend/monitoring';

import styles from './no-team-option.module.scss';

export const NO_TEAM_VALUE = 0;

const NoTeamOption = () => {
	const { noTeam, noTeamInfo } = useMonitoringTranslations();

	return (
		<span className={styles.noTeamOption}>
			{noTeam}
			<BringgPopover
				content={
					<div className={styles.popOver}>
						<div className={styles.popOverHeader}>{noTeam}</div>
						<div className={styles.popOverContent}>{noTeamInfo}</div>
					</div>
				}
				trigger={['hover']}
				placement="right"
			>
				<Button
					type="link"
					shape="circle"
					size="small"
					icon={
						<BringgIcon iconName={BringgFontIcons.CircleExclamation} className={styles.exclamationIcon} />
					}
				/>
			</BringgPopover>
		</span>
	);
};

export const noTeamOption = {
	label: <NoTeamOption />,
	value: NO_TEAM_VALUE,
	children: []
};
